import { ReorderSectionUpdate, UpdateTask } from '@griply/types';
import { buildUpcomingReorderUserSettings } from '@griply/utils';
import { useUpdateUserSettings } from 'features/user';
import { useCallback } from 'react';
import { useToday } from 'shared/contexts/today';
import { useUpdateTasksMutation } from 'shared/hooks/queries/use-update-tasks-mutation';

export const useUpcomingListOnReorder = () => {
  const today = useToday();
  const updateSettings = useUpdateUserSettings();
  const { mutate: updateTasks } = useUpdateTasksMutation();

  return useCallback(
    (updatedSections: ReorderSectionUpdate[], updatedTasks: UpdateTask[]) => {
      const settingsUpdate = buildUpcomingReorderUserSettings({
        updatedSections,
        today,
      });
      if (settingsUpdate) {
        updateSettings(settingsUpdate);
      }

      if (updatedTasks.length) {
        updateTasks(updatedTasks);
      }
    },
    [today, updateSettings, updateTasks],
  );
};
